import { gql } from "@apollo/client";
import { AddressInfoFragment } from "graphql/Address/fragments";
import { ConveyorInfoFragment, DriverInfoFragment } from "graphql/Papser/fragments";
import { ParcelInfoFragment } from "graphql/Parcel/fragments";

const ActivityFragment = gql`
  fragment ActivityFragment on Activity {
    _id
    activity_date
    activity_trigger_action
    activity_trigger_action_data
    activity_trigger_action_data_reason
    activity_trigger_source
    activity_source_UID
    activity_trigger_by_user_type
    activity_updated_by {
      _id
      first_name
      last_name
      email
      phone_number
    }
    activity_source_context
  }
`;
const AddressFragment = gql`
  fragment AddressFragment on Address {
    country
    city
    region
    address
    location {
      latitude
      longitude
    }
    place_id
  }
`;
export const SubTaskInfoFragment = gql`
  fragment SubTaskInfo on SubTask {
    _id
    subtask_for_paps
    subtask_UID
    subtask_status
    subtask_type
    subtask_operation_on_parcel {
      ...ParcelInfo
    }
    subtask_client_UID
    subtask_address {
      ...AddressInfo
    }
    subtask_address {
      ...AddressInfo
    }

    subtask_execution_date
    subtask_execution_slot_start
    subtask_execution_slot_end
    subtask_created_at
    subtask_last_edited_at

    subtask_driver {
      ...DriverInfo
    }
    subtask_conveyor {
      ...ConveyorInfo
    }
    subtask_recipient {
      receiver_firstname
      receiver_lastname
    }
    service
  }
  ${ParcelInfoFragment}
  ${AddressInfoFragment}
  ${DriverInfoFragment}
  ${ConveyorInfoFragment}
`;

export const SubtaskSuscribtions = gql`
  subscription subtasks($clientUID: ID) {
    subtasks(clientUID: $clientUID) {
      ...SubTaskInfo
    }
  }
  ${SubTaskInfoFragment}
`;

export const TasksListFragment = gql`
  fragment TasksListFragment on Task {
    _id
    task_UID
    missionUid
    task_client {
      client_company_name
    }
    task_driver {
      _id
      driver_lastname
      driver_firstname
      driver_phone_number
    }
    task_conveyor {
      _id
      conveyor_firstname
      conveyor_lastname
    }
    task_type
    task_status
    task_execution_date
    task_execution_slot_start
    task_execution_slot_end
    task_driver_UID
    task_vehicle_type
    task_created_at
    task_subtasks {
      _id
      subtask_UID
      subtask_type
      subtask_status
      subtask_driver_UID
      subtask_execution_date
      subtask_execution_slot_start
      subtask_execution_slot_end
      subtask_address {
        ...AddressFragment
      }
      subtask_operation_on_parcel {
        _id
        parcel_UID
        parcel_description
        parcel_amount_to_collect
      }
      service
      pickedItems {
        description
        quantity
      }
      deliveredItems {
        description
        quantity
      }
      itemsToDelivered {
        description
        quantity
        pickup
      }
    }
    task_vehicule {
      _id
      vehicle_UID
      vehicle_type
    }
    request {
      startDate
      endDate
      _id
      uid
    }
    toTransfer
    activities {
      ...ActivityFragment
    }
    otherReason
  }
  ${ActivityFragment}
  ${AddressFragment}
`;
